module.exports = __webpack_public_path__ + "static/fonts/PlayfairDisplayregular.a8d987dc.ttf";